import {exhibitionActions} from "../../reducers/exhibition";

export const resetCreateExhibition = (dispatch) => {
    dispatch(exhibitionActions.setExhibitionRoom({
        id: null,
        seq: null,
        imageAltText: "",
        name: "",
        introduction: "",
        roomNo: "",
        invalid: true,
        language: { id: 1 },
        parentId: null,
        imageUrl: null,
        commentator: { id : null },
        commentatorForKid: { id : null },
        commentatorForBlind: { id : null },
    }))
    dispatch(exhibitionActions.setType('kor'));
    dispatch(exhibitionActions.setSubTopicList([]));
    dispatch(exhibitionActions.setFile(null));
    dispatch(exhibitionActions.setPreviewImage(null));
}
